<!--
 * @Author: 'llhj' llhj0326@163.com
 * @Date: 2024-03-06 17:57:26
 * @LastEditors: 'llhj' llhj0326@163.com
 * @LastEditTime: 2025-08-14 17:07:06
 * @FilePath: \front\src\views\Patient\components\user-log.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div class="log-wrap">
		<template v-for="item in list.data">
		<div class="item" :class="{out:  item.dataType == 1, in: item.dataType == 0, follow:  item.dataType == 3, appo:  item.dataType == 2,reVisit:item.dataType == 4}" :key="item.id">
			<template v-if="item.dataType == 0">
				<router-link class="noline" :to="{name: 'Patient/User', query: {patientId: item.patientId, t: 3, fid: item.recordId,datasources:item.datasources}}"><span class="date" v-text="item.pointTime"></span></router-link>
			</template>
			<template v-if="item.dataType == 1">
				<router-link class="noline" :to="{name: 'Patient/User', query: {patientId: item.patientId, t: 3, fid: item.recordId,datasources:item.datasources}}"><span class="date" v-text="item.pointTime"></span></router-link>
			</template>
			<template v-if="item.dataType == 2">
				<router-link class="noline" :to="{name: 'Patient/User', query: {patientId: item.patientId, t: 3, fid: item.recordId,datasources:item.datasources}}"><span class="date" v-text="item.pointTime"></span></router-link>
			</template>
			<template v-if="item.dataType == 3">
				<router-link class="noline" :to="{name: 'Patient/User', query: {patientId: item.patientId, t: 5, date: item.expectFollowupDate}}"><span class="date" v-text="item.pointTime"></span></router-link>
			</template>
			<template v-if="item.dataType == 4">
				<router-link class="noline" :to="{name: 'Patient/User', query: {patientId: item.patientId, t: 3,datasources:item.datasources,t2:3}}"><span class="date" v-text="item.pointTime"></span></router-link>
			</template>
			<span class="event" v-text="item.description"></span>
			<span class="dep" v-text="item.department"></span>
			<span class="creator" v-text="item.creator"></span>
		</div>
		</template>
	</div>
</template>

<script>
import api from '@/service/api.js';
import mixin from '@/views/mixin';

export default {
  mixins: [mixin],
	props: {
		patientId: {required: true}
	},
	watch: {
		patientId(newV, oldV) {
			if (newV && (newV != oldV)) {
				this.init();
			}
		}
	},
	data(){
		return {
			noSidebar: true,
			list: {
				current: 1,
				total: 0,
				pageSize: 0,
				data: null
			}
		}
	},
	created() {if (this.patientId) {this.init();}},
	methods: {
		init() {
			api.getPatientLogList({patientId: this.patientId, pageNumber: 1, pageSize: 99999}).then((res)=>{
				if (res.code == 1000 && res.data) {
					this.list.data = res.data;	
				}
			});
		}
	}
}
</script>

<style lang="less" scoped>
@import './user-bio.less';
</style>
